import React from 'react';

type Props = {
  name: string;
  create?: () => void;
  icon?: React.ReactNode;
  children?: React.ReactNode;
};

export const NoRowsFound: React.FC<Props> = ({
  name,
  create,
  icon,
  children = 'No records found.',
}) => {
  return (
    <div className="text-center p-6 bg-white dark:bg-dark-gray-800 rounded-lg">
      {icon ? icon : <DefaultIcon />}
      <h3 className="mt-2 text-sm font-medium text-gray-900 dark:text-white">{children}</h3>
    </div>
  );
};

export default NoRowsFound;

const DefaultIcon = () => (
  <svg
    className="mx-auto h-12 w-12 text-gray-400 dark:text-white"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    aria-hidden="true"
  >
    <path
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
    />
  </svg>
);
